/**
 * @ngdoc object
 * @name picklists
 * @description
 *
 */
angular
    .module('festzelt-os.vouchers.main', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./main-routes');

// Controllers
require('./controllers/details-controller');
require('./controllers/list-controller');
require('./controllers/modals/split-voucher-modal-controller');
require('./controllers/modals/create-residual-modal-controller');

// Factories
require('./factories/voucher-factory');

// Store
require('./store/vouchers');

// Workflows
require('./workflows/print-vouchers');
require('./workflows/send-vouchers');



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/main-module.js